import { useRef } from 'react';
import AircraftInfiniteList from './aircraftInfiniteList';
import FilterListAircraft from '../utils/filterLists/filterListAircraft';
import ListPageLayout from '../utils/ListPageLayout';

function AircraftsPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Aircraft"
        tagline="The various planes used by the Eighth Air Force."
        sidebar={<FilterListAircraft isFiltered={handleQuery} />}
      >
        <AircraftInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default AircraftsPage;
